<div class="dialog">
  <img src="/assets/stellantis/truck.png" alt="Free Shipping!">

  <p>Deliver to:</p>
  <button class="deliver-to" (click)="onSelect()">
    <span>Paris, France</span>
    <img src="/assets/icons/countries/france.svg" alt="France flag" width="40px" height="30px">
  </button>
</div>
